import { Button, Container, Flex, Heading, useToast } from '@chakra-ui/react'
import { AxiosError } from 'axios'
import { CreateFlexGroup } from 'brokertslib/src/dtos'
import { useCreate } from 'brokertslib/src/hooks/useFlexGroup'
import { useNavigate } from 'react-router-dom'

import { Section } from '@/components/Section'
import { FlexGroupForm } from '@/containers/flex-group/FlexGroupForm'
import { PageContent } from '@/containers/PageContent'
import { PageToolbar } from '@/containers/PageToolbar'
import { ArrowLeft } from '@/icons'

export const FlexGroupCreatePage = () => {
  const navigate = useNavigate()
  const toast = useToast()
  const { mutateAsync: create } = useCreate()

  const onSubmit = (data: CreateFlexGroup) => {
    create(data)
      .then((flexGroup) => {
        navigate(`/flex-group/${flexGroup.data.id}`)
      })
      .catch((e: AxiosError) => {
        toast({
          title: 'Chyba při vytváření flexibilní skupiny',
          description: `${e.response?.status}: ${e.response?.statusText}`,
          status: 'error',
        })
      })
  }

  return (
    <Section>
      <Container>
        <PageContent>
          <PageToolbar
            sx={{ w: '2xl', margin: '0 auto' }}
            leftElements={
              <Flex sx={{ gap: 4, alignItems: 'center' }}>
                <Heading as="h1">Nová flexibilní skupina</Heading>
              </Flex>
            }
            rightElements={
              <Flex sx={{ gap: 4 }}>
                <Button
                  variant="ghost"
                  onClick={() => navigate('/flex-group/list')}
                >
                  <ArrowLeft color="secondary.500" />
                  Zpět na přehled flexibilních skupin
                </Button>
              </Flex>
            }
          />

          <FlexGroupForm
            flexGroup={{ name: '', description: '' }}
            create
            onSubmit={onSubmit}
          />
        </PageContent>
      </Container>
    </Section>
  )
}
